import React, { useState } from "react";
import { OutlineButton } from "./Buttons";
import { Microsoft as MicrosoftIcon } from "@mui/icons-material";
import { Stack,Typography } from "@mui/material";
import { getAuth, signInWithPopup, OAuthProvider} from 'firebase/auth';
import { useLoginState,LoginData } from "./LoginState";
import { trackEvent } from "../../libs/analyticsManager";

const microsoftProvider = new OAuthProvider('microsoft.com');
microsoftProvider.setCustomParameters({ prompt: 'consent', tenant: 'common'});

interface MicrosoftAuthProps {
  authSuccess?: (loginData: LoginData,isNewUser:boolean, mailingList?: boolean) => Promise<any>;
  buttonText?: string;
  disable?: boolean;
}

export const MicrosoftAuth = ({authSuccess, buttonText='Sign up with Microsoft', disable=false }: MicrosoftAuthProps) => {
    const [label,setLabel] = useState(buttonText);
    const [disabled,setDisabled] = useState(disable)
    const setOrCreateProfile = useLoginState((state) => state.setOrCreateProfile);

    const handleClick =  async () => {
      try {
        setDisabled(true)
        const auth = getAuth()
        const result:any = await signInWithPopup(auth, microsoftProvider);
        const loginData:LoginData = { user:result.user, providerId: result.providerId, _tokenResponse: result._tokenResponse } as LoginData
        const resp = await setOrCreateProfile(loginData, true)
        const isNewUser = result.additionalUserInfo?.isNewUser ?? result._tokenResponse?.isNewUser;
        if (isNewUser) {
          if (window.gtag) window.gtag("event", "signup");
          if (window.gtag) window.gtag("event", "signup_microsoft");
          trackEvent("signup", { source: "microsoft" });
        } else {
          if (window.gtag) window.gtag("event", "signin");
          trackEvent("signin", { source: "microsoft" });
        }
        if (authSuccess) await authSuccess(loginData,isNewUser, true)
      }
      catch (error) { console.log('Error!!! ', error) }
      finally{ setDisabled(false) }
    }
    return (
        <OutlineButton
            onClick={handleClick} fullWidth variant="outlined"
            className="microsoft-btn"
            style={{ marginTop:'5px',marginBottom: "15px" }}
            disabled={disabled}
        >
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
            <MicrosoftIcon sx={{ paddingTop:'0px',color: "#4285F4" }} />
            <Typography sx={{fontSize:'0.875rem'}}>{label}</Typography>
          </Stack>
        </OutlineButton>
    )
};
